// extracted by mini-css-extract-plugin
export default {"AdditionalInfoContainer":"RestorePassword_AdditionalInfoContainer__d3bS3","Link":"RestorePassword_Link__hsFJc","Test":"RestorePassword_Test__Uzx7J"};